import { render } from "./InvestedInfo.vue?vue&type=template&id=7401f59d"
import script from "./InvestedInfo.vue?vue&type=script&lang=js"
export * from "./InvestedInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__